module.exports = __webpack_public_path__ + "img/Flexport_logo.18b4524b.svg";